import axios from '@/api/ai-axios';
import LoadingSpinner from '@/components/loading-spinner';
import { useImmer } from 'use-immer';
import { getUrlParams } from './utils/url-parse';
import { message } from 'antd';
import { useCallback, useEffect } from 'react';
import { setLocalStorageExpire } from './utils/cookie-tool';
import { useDispatch } from 'react-redux';
import { setUID } from '@/reducers/users';
import useAuth from '@/hooks/useAuth';

let expiresTime = 60 * 24 * 30; // cookie过期时间, 单位：分钟

const ParseTokenLoginHOC = (WrappedComponent) => {
  const TokenLoginWrapper = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useImmer(true);
    const { checkLogin } = useAuth();

    useEffect(() => {
      tokenLogin();
    }, []);

    const tokenLogin = useCallback(async () => {
      try {
        const token = getUrlParams('token');

        if (!token) {
          return;
        }
        try {
          const res = await axios.post('/api/yixiao/robocodeCheckToken', {
            token: token,
          });

          if (res.status == 1) {
            const uid = res.data.uid;
            // 登录成功
            setLocalStorageExpire('uid', uid, expiresTime);
            dispatch(setUID(uid));
            checkLogin();
          } else {
            // 登录失败
            message.error(res.message || res || 'token校验失败');
          }
        } catch (err) {
          // axios 已处理了异常
        }
      } catch (err) {
        message.error(err.message || err);
      } finally {
        setLoading(false);
      }
    }, [checkLogin, dispatch]);

    return loading ? (
      <LoadingSpinner loading={true} />
    ) : (
      <WrappedComponent {...props} />
    );
  };

  return TokenLoginWrapper;
};

export default ParseTokenLoginHOC;
